/**
 * Cognito requires phone_number in E.164 format (+15551234567).
 * Accepts common US formats and anything already E.164; returns null if unusable.
 */
export function toE164(raw: string): string | null {
  const trimmed = raw.trim();

  if (trimmed.startsWith('+')) {
    const digits = trimmed.slice(1).replace(/\D/g, '');
    return digits.length >= 8 && digits.length <= 15 ? `+${digits}` : null;
  }

  const digits = trimmed.replace(/\D/g, '');
  if (digits.length === 10) return `+1${digits}`;
  if (digits.length === 11 && digits.startsWith('1')) return `+${digits}`;
  return null;
}

/**
 * Turns E.164 into something readable: +18474772032 -> (847) 477-2032.
 * Non-US or unexpected lengths are returned unchanged rather than mangled.
 */
export function formatPhone(value: string): string {
  const digits = (value ?? '').replace(/\D/g, '');
  const local = digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;

  if (local.length !== 10) return value;

  return `(${local.slice(0, 3)}) ${local.slice(3, 6)}-${local.slice(6)}`;
}
